export const clientConfig = {
  jumpLinks: {
    min: 3,
    max: 6,
  },
}
